module.exports = __webpack_public_path__ + "fonts/Catamaran-Medium.f1dd472e.woff2";